import { Card } from '@popsure/dirty-swan';
import SectionHeader from 'components/sectionHeader';
import { useSafeTranslation } from 'shared/i18n';
import englishFormattedEuroCurrency from 'shared/util/priceFormatter';

interface AdjustedPolicyProps {
  currentPrice?: number;
  newPrice: number;
}

export const AdjustedPrice = ({
  currentPrice,
  newPrice,
}: AdjustedPolicyProps) => {
  const { t } = useSafeTranslation();
  if (!currentPrice || currentPrice === newPrice) {
    return null;
  }

  const perMonthLabel = t('components.quote.adjustedPrice.perMonth', '/mo');

  return (
    <div
      className="bg-grey-100 pt72 pb72 mb80"
      data-testid="quote-adjusted-price"
    >
      <section className="p-body">
        <SectionHeader
          title={t('components.quote.adjustedPrice.title', 'Adjusted price')}
        />
        <Card
          density="spacious"
          classNames={{ wrapper: 'mt24' }}
          dropShadow={false}
        >
          <div className="d-flex jc-between mb16 p-p">
            <p>
              {t(
                'components.quote.adjustedPrice.currentPrice',
                'Current price'
              )}
            </p>
            <span>
              {englishFormattedEuroCurrency(currentPrice)}
              {perMonthLabel}
            </span>
          </div>

          <div className="d-flex jc-between mb24 p-p">
            <p>
              {t(
                'components.quote.adjustedPrice.priceDifference',
                'Price difference'
              )}
            </p>
            <span>
              {newPrice > currentPrice ? '+' : ''}
              {englishFormattedEuroCurrency(newPrice - currentPrice)}
              {perMonthLabel}
            </span>
          </div>

          <div className="d-flex ai-center jc-between">
            <h3 className="p-h3">
              {t('components.quote.adjustedPrice.newPrice', 'New price')}
            </h3>
            <h2 className="p-h2">
              {englishFormattedEuroCurrency(newPrice)}
              {perMonthLabel}
            </h2>
          </div>
        </Card>
      </section>
    </div>
  );
};
